import { Container, Grid,Typography } from '@mui/material'
import styled from '@emotion/styled'

const CommunityGrid = styled(Grid)`
    transform: rotate(355deg);
    padding: 150px 0px 200px 0px;
    @media (max-width: 600px){
        padding: 20px 0px 150px 0px;
    }
`
const Heading = styled(Typography)`
    font-size: 60px;
    font-family: poppinBI;
    text-align: center;
    color: #fff;
    text-transform: uppercase;
    -webkit-text-stroke: 1px black;
    @media (max-width: 1065px) and (min-width: 600px){
        font-size: 30px;
    }
    @media (max-width: 600px){
        font-size: 16px;
    }
`
const MainContainer = styled(Container)`
        width: calc(100% + 10%);
    margin-left: -4%;
    padding-left:0px;
    padding-right:0px;
    @media(min-width: 1600px){
        margin-top: 6%;
    }
`
const MarqueeImg = styled.img`
    width:100%;
    margin-right:20px;
`
const GridContainer = styled(Grid)`
    padding: 0px;
`
const DividerImg = styled.img`
    width: calc(100% + 10%);
    margin-left: -2%;
`
export {CommunityGrid,Heading,MainContainer,MarqueeImg,GridContainer,DividerImg}
